import * as React from "react";
import { forwardRef } from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgOnePerson = ({ title, titleId, ...props }, ref) => /* @__PURE__ */ _jsxs("svg", {
	xmlSpace: "preserve",
	width: "100%",
	height: "100%",
	viewBox: "2160.47119140625 -3596.3623046875 14488.44140625 19180.919921875",
	style: {
		shapeRendering: "geometricprecision",
		textRendering: "geometricprecision",
		fillRule: "evenodd",
		clipRule: "evenodd"
	},
	ref,
	"aria-labelledby": titleId,
	...props,
	children: [title ? /* @__PURE__ */ _jsx("title", {
		id: titleId,
		children: title
	}) : null, /* @__PURE__ */ _jsxs("g", {
		id: "Layer_x0020_1",
		children: [/* @__PURE__ */ _jsx("metadata", { id: "CorelCorpID_0Corel-Layer" }), /* @__PURE__ */ _jsx("g", {
			id: "_630867408",
			children: /* @__PURE__ */ _jsx("path", {
				className: "fil0",
				d: "M7336 6759c0,-147 11,-133 43,-251l591 -2149c206,-410 379,-325 650,-325l1579 0c296,0 445,-71 640,320l445 1567 125 495c43,107 60,234 60,358 0,147 -261,341 -452,81 -35,-48 -150,-536 -172,-634l-240 -967c-38,-152 -19,-229 -204,-229 -116,0 -139,108 -151,205l-4 4702c0,113 10,249 -18,338 -85,270 -456,205 -478,-44l0 -2229 1 -666c0,-152 25,-191 -124,-190l-467 4c-127,-5 -90,60 -91,403l-5 2688c-52,241 -360,286 -474,67 -60,-114 -32,-890 -32,-1052l0 -3622c0,-129 42,-604 -123,-604 -186,0 -196,39 -239,226 -45,200 -352,1526 -404,1608 -156,244 -456,77 -456,-100zm2058 -3050l0 0c-245,0 -581,-142 -755,-313 -322,-318 -427,-804 -225,-1225 374,-779 1417,-835 1875,-162 287,420 252,996 -132,1379 -200,199 -478,321 -763,321zm-1080 -347l0 0c114,163 272,299 471,415 32,19 14,5 37,25 -620,0 -822,-73 -1120,598l-517 1929c-66,312 -174,527 100,774 216,195 657,145 772,-319l167 -669c17,-69 82,-403 118,-455l0 4442c-1,209 26,376 198,484 405,253 746,-87 746,-344l0 -2864 232 0 0 2848c0,410 657,679 904,176 81,-165 56,-389 56,-625l0 -4055 324 1199c31,115 122,182 178,219 175,114 455,85 593,-76 35,-41 61,-81 85,-132 111,-237 -18,-452 -64,-702l-503 -1858c-61,-228 -204,-387 -328,-468 -244,-160 -437,-102 -780,-102 429,-219 863,-711 684,-1490 -155,-676 -852,-1112 -1525,-974 -405,84 -761,359 -934,735 -184,398 -147,930 106,1289z",
				fill: "#808080"
			})
		})]
	})]
});
const ForwardRef = forwardRef(SvgOnePerson);
export default ForwardRef;
